import * as _ from "lodash";
import * as log from "loglevel";
import * as marked from "marked";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Message, Modal } from "semantic-ui-react";
import { ReleaseNote } from "../components/release-note";
import { ReleaseNoteStore } from "../stores/releasenote-store";
import { UIStore } from "../stores/ui-store";

declare var hopscotch: any;

interface IProjectDashboardProps{
	close;
	uiStore?: UIStore;
	releaseNoteStore?: ReleaseNoteStore;
}

interface IProjectDashboardState{
}


@inject("uiStore", "releaseNoteStore") @observer
export class ReleaseNoteModal extends React.Component<IProjectDashboardProps, IProjectDashboardState>{
	constructor(props, state){
		super(props, state);
	}


	async componentWillMount(){

	}

	render(){
		return(
		<Modal basic closeIcon={true} open={true} style={{"overflow": "hidden"}} onClose={this.props.close} closeOnDimmerClick={true}>
			<Modal.Header>Release Notes</Modal.Header>
			<Modal.Description style={{"marginBottom": "25px", "marginTop": "20px"}}>
				{this.props.releaseNoteStore.notes.map((releaseNote, index) => {
					return (<ReleaseNote key={index} releaseNote={releaseNote} />);
				})}
			</Modal.Description>
		</Modal>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/release-note-modal.tsx